import axios from '../../../utils/AxiosUtils';
import i18n from '../../../i18next';
import MessageUtils from "../../../utils/MessageUtils";
import { LOADING, GET_CUSTOMER_INFO_SEARCH, IS_INSIGHTS_DISABLED } from '../../types';
import { SERVER_URL } from '../../../utils/Constants';

export const downloadCustomersData = (restaurantId, startDate, endDate, callback) => {
    return (dispatch) => {
        dispatch({ type: LOADING, payload: true });

        const url = `restaurant/${restaurantId}/customer-data?ordersFromDate=${startDate}&ordersToDate=${endDate}`;

        axios().get(url)
            .then(res => {
                let blob = new Blob([res.data], { type: 'application/csv' });
                let link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = `customers-data-from-${startDate}-to-${endDate}.csv`;
                link.click();
                if (callback) {
                    callback();
                }
            })
            .catch(err => MessageUtils.errorMessageResponse(
                dispatch, err.response.data, i18n.t('actions:restaurantsActions.downloadFail')))
            .finally( dispatch({ type: LOADING, payload: false }));
    }
}

export const getCustomersInfo = (searchQuery, pageNumber, restaurantId) => {
    return(dispatch) => {
        dispatch({ type: LOADING, payload: true });

        let updatedSearchQuery = {...searchQuery};
        const finalSearchQuery = getQueryParams(updatedSearchQuery, pageNumber, restaurantId);
        const url = `${SERVER_URL}/restaurant/customer-status-search?${finalSearchQuery}`;

        axios().get(url)
        .then(response => getCustomersInfoSuccess(dispatch, response))
        .catch(error => getCustomersInfoFail(dispatch, error));
    }
}

const getCustomersInfoSuccess = (dispatch, response) => {
    dispatch({ type: LOADING, payload: false });
    dispatch({ type: IS_INSIGHTS_DISABLED, payload: false });
    dispatch({ type: GET_CUSTOMER_INFO_SEARCH, payload: response.data });
};

const getCustomersInfoFail = (dispatch, error) => {
    dispatch({ type: LOADING, payload: false });

    if (error.response.status === 401) {
        dispatch({ type: IS_INSIGHTS_DISABLED, payload: true });
    } else {
        dispatch({ type: IS_INSIGHTS_DISABLED, payload: false });
    }
}

const getQueryParams = (searchQuery, pageNumber, restaurantId) => {
    const {
        name,
        phone,
        status,
        email,
        isVip
    } = searchQuery;
    let pageParam = '',
        sizeParam = '',
        restaurantIdParam = '',
        nameParam = '',
        phoneParam = '',
        statusParam = '',
        emailParam = '',
        isVipParam = ''
    pageParam = pageNumber;
    sizeParam = 10; // backend default 20


    if (restaurantId) {
        restaurantIdParam = `&restaurantId=${restaurantId}`
    }

    if (name) {
        nameParam = `&name=${name}`
    }

    if (phone) {
        phoneParam = `&phone=${phone}`
    }

    if (status) {
        statusParam = `&status=${setQueryCustomerStatus(status)}`
    }

    if (email) {
        emailParam = `&email=${email}`
    }

    if (isVip) {
        isVipParam = `&isVip=${isVip}`
    }

    return `page=${pageParam}&size=${sizeParam}${restaurantIdParam}${nameParam}${phoneParam}${statusParam}${emailParam}${isVipParam}`;
}

const setQueryCustomerStatus = (currentStatus) => {
    switch(currentStatus) {
        case 'Regular':
            return 0;
        case 'Infrequent':
            return 1;
        case 'At Risk': 
            return 2;
        case 'Lost': 
            return 3;
        default :
            return null;
    }
}


// WEBPACK FOOTER //
// ./src/actions/restaurants/customers/CustomersAction.js